<app-header></app-header>

<div class="container-xxl">
  <section class="banner d-flex justify-content-center align-items-center text-center">
    <div class="content" data-aos="zoom-in" data-aos-duration="2000">
      <div class="title">
        <span>المجموعات</span>
      </div>
    
      <div class="links">
        <a class="text-decoration-none" routerLink="/home"> الرئيسية </a>
        <span> / </span>
        <a class="text-decoration-none" routerLink="/"> القسم </a> 
        <span> / </span>
        <a class="text-decoration-none" routerLink="/"> الدورة التدريبية </a>        
        <span>/ المجموعات </span>
      </div>
    </div>
  </section>
  
   <section class="all-classes">
     <div class="container">
      <div class="row d-flex justify-content-center align-items-center mt-5 mb-5" >
        <div  *ngFor="let class of classList">
          <div class="content mt-5 mb-5 text-center" style="cursor: pointer;"  routerLink="/getClassById/{{class._id}}" data-aos="flip-left" data-aos-duration="2000">
            <div class="frame d-flex justify-content-center align-items-center mb-4">
              <i class="fas fa-user-graduate"></i>
            </div>            
            <h3>اسم المجموعة: {{class.Number}}</h3>            
            <p class="">اقل سن مسموح بيه للطلاب: {{class.StudentsMinAge}}</p>
            <p class="">اكبر سن مسموح بيه للطلاب: {{class.StudentsMaxAge}}</p>
            <p class="">الجنــــس: {{class.StudentGender}}</p>
          </div>        
        </div>
      </div>
      {{errorMsg}}
     </div>
   </section>
</div>

  <app-footer></app-footer>